/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "padlock-locked-80c690a9--sprite",
  "use": "padlock-locked-80c690a9--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"padlock-locked-80c690a9--sprite\"><defs><clipPath id=\"padlock-locked-80c690a9--sprite_b\"><rect width=\"36\" height=\"36\" /></clipPath></defs><g id=\"padlock-locked-80c690a9--sprite_a\" clip-path=\"url(#padlock-locked-80c690a9--sprite_b)\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(9047.095 17779.771)\"><path d=\"M-172.907,130.451h-.751v-2.387a5.254,5.254,0,0,0-5.254-5.254,5.254,5.254,0,0,0-5.254,5.254v2.387h-.75a.75.75,0,0,0-.751.744v8.893a.735.735,0,0,0,.734.736h12.025a.74.74,0,0,0,.75-.728v-8.9A.75.75,0,0,0-172.907,130.451ZM-177.861,136a1.18,1.18,0,0,1-.3.239v.947a.75.75,0,0,1-.751.75.75.75,0,0,1-.75-.75v-.947a1.5,1.5,0,0,1-.751-1.3,1.471,1.471,0,0,1,.443-1.059,1.477,1.477,0,0,1,2.089-.02l.02.02a1.47,1.47,0,0,1,.039,2.078Zm-4.8-5.547v-2.387a3.753,3.753,0,0,1,3.753-3.753,3.753,3.753,0,0,1,3.753,3.753v2.387Z\" transform=\"translate(-8850.183 -17894.918)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
